import { HeaderTabType } from '../enums';
import { Tab } from '../components/layout/HeaderTabs';

export const TABS: Tab[] = [
    { title: 'Expert Suite', to: '/', type: HeaderTabType.Home }
];
